export { default as getMailboxInfo, getMailboxInfoFromTableQuery } from './getMailboxInfo';
export { default as getCurrentTableMailboxInfo } from './getCurrentTableMailboxInfo';
//# sourceMappingURL=index.js.map